import React, { createContext, useState } from "react";
import { common } from "utils/constant";
export const ConditionContext = createContext();
export const ConditionProvider = ({ children }) => {
  const [hasToShowInLeftDrawer, setHasToShowInLeftDrawer] = useState("");
  const [privateChatWith, setPrivateChatWith] = useState({
    guid: "",
    userId: "",
  });
  const [chatWithGroupIndividual, setChatWithGroupIndividual] =
    useState("group");

  const privateChatWithSetter = (user) => {
    setPrivateChatWith(user);
  };
  const chatWithGroupIndividualSetter = (value) => {
    setChatWithGroupIndividual(value);
  };

  // ===================================================
  const [openedComponentDrawer, setOpenedComponentDrawer] = useState("");
  const [interViewTypeToChat, setInterViewTypeToChat] = useState(
    common.general
  );

  const interViewTypeToChatSetter = (typeName) => {
    setInterViewTypeToChat(typeName);
  };

  const openedComponentDrawerSetter = (componentName) => {
    if (componentName === openedComponentDrawer) {
      setOpenedComponentDrawer("");
    } else {
      setOpenedComponentDrawer(componentName);
    }
  };

  return (
    <ConditionContext.Provider
      value={{
        hasToShowInLeftDrawer,
        setHasToShowInLeftDrawer,
        chatWithGroupIndividualSetter,
        chatWithGroupIndividual,
        privateChatWithSetter,
        privateChatWith,
        setOpenedComponentDrawer,
        openedComponentDrawerSetter,
        openedComponentDrawer,
        interViewTypeToChat,
        interViewTypeToChatSetter,
      }}
    >
      {children}
    </ConditionContext.Provider>
  );
};
